import Toastify from "toastify-js";

const Notify = {

    notify(message, options) {
        const defaultOptions = { close: true, duration: 1500 };
        options = {...defaultOptions, ...options};
        options.className = `mdi ${options.className}`

        Toastify({
            text: message,
            duration: options.duration,
            className: options.className,
            close: options.close
        }).showToast();
    },

    info(message) {
        this.notify(message, {className: 'mdi-information-variant info'})
    },

    error(message) {
        Notify.notify(message, {className: 'mdi-close error'})
    },

    success(message) {
        Notify.notify(message, {className: 'mdi-check success'})
    }
};

export default Notify;
